const arr = [
  {
    id: 1,
    name: "北京",
    pinyin: "BEIJING",
    children: [
      {
        id: 2,
        name: "北京",
        zipCode: "100000",
        pinyin: "BEIJING"
      }
    ]
  },
  {
    id: 19,
    name: "天津",
    pinyin: "TIANJIN",
    children: [
      {
        id: 20,
        name: "天津",
        zipCode: "300000",
        pinyin: "TIANJIN"
      }
    ]
  },
  {
    id: 37,
    name: "河北",
    pinyin: "HEBEI",
    children: [
      {
        id: 38,
        name: "石家庄",
        zipCode: "050011",
        pinyin: "SHIJIAZHUANG"
      },
      {
        id: 61,
        name: "唐山",
        zipCode: "063000",
        pinyin: "TANGSHAN"
      },
      {
        id: 76,
        name: "秦皇岛",
        zipCode: "066000",
        pinyin: "QINHUANGDAO"
      },
      {
        id: 84,
        name: "邯郸",
        zipCode: "056002",
        pinyin: "HANDAN"
      },
      {
        id: 104,
        name: "邢台",
        zipCode: "054001",
        pinyin: "XINGTAI"
      },
      {
        id: 124,
        name: "保定",
        zipCode: "071052",
        pinyin: "BAODING"
      },
      {
        id: 150,
        name: "张家口",
        zipCode: "075000",
        pinyin: "ZHANGJIAKOU"
      },
      {
        id: 168,
        name: "承德",
        zipCode: "067000",
        pinyin: "CHENGDE"
      },
      {
        id: 180,
        name: "沧州",
        zipCode: "061001",
        pinyin: "CANGZHOU"
      },
      {
        id: 197,
        name: "廊坊",
        zipCode: "065000",
        pinyin: "LANGFANG"
      },
      {
        id: 208,
        name: "衡水",
        zipCode: "053000",
        pinyin: "HENGSHUI"
      }
    ]
  },
  {
    id: 220,
    name: "山西",
    pinyin: "SHANXI",
    children: [
      {
        id: 221,
        name: "太原",
        zipCode: "030082",
        pinyin: "TAIYUAN"
      },
      {
        id: 232,
        name: "大同",
        zipCode: "037008",
        pinyin: "DATONG"
      },
      {
        id: 244,
        name: "阳泉",
        zipCode: "045000",
        pinyin: "YANGQUAN"
      },
      {
        id: 250,
        name: "长治",
        zipCode: "046000",
        pinyin: "CHANGZHI"
      },
      {
        id: 264,
        name: "晋城",
        zipCode: "048000",
        pinyin: "JINCHENG"
      },
      {
        id: 271,
        name: "朔州",
        zipCode: "038500",
        pinyin: "SHUOZHOU"
      },
      {
        id: 278,
        name: "晋中",
        zipCode: "030600",
        pinyin: "JINZHONG"
      },
      {
        id: 290,
        name: "运城",
        zipCode: "044000",
        pinyin: "YUNCHENG"
      },
      {
        id: 304,
        name: "忻州",
        zipCode: "034000",
        pinyin: "XINZHOU"
      },
      {
        id: 319,
        name: "临汾",
        zipCode: "041000",
        pinyin: "LINFEN"
      },
      {
        id: 337,
        name: "吕梁",
        zipCode: "033000",
        pinyin: "LVLIANG"
      }
    ]
  },
  {
    id: 351,
    name: "内蒙古",
    pinyin: "NEI MONGOL",
    children: [
      {
        id: 352,
        name: "呼和浩特",
        zipCode: "010000",
        pinyin: "HOHHOT"
      },
      {
        id: 362,
        name: "包头",
        zipCode: "014025",
        pinyin: "BAOTOU"
      },
      {
        id: 372,
        name: "乌海",
        zipCode: "016000",
        pinyin: "WUHAI"
      },
      {
        id: 376,
        name: "赤峰",
        zipCode: "024000",
        pinyin: "CHIFENG"
      },
      {
        id: 389,
        name: "通辽",
        zipCode: "028000",
        pinyin: "TONGLIAO"
      },
      {
        id: 398,
        name: "鄂尔多斯",
        zipCode: "017004",
        pinyin: "ORDOS"
      },
      {
        id: 407,
        name: "呼伦贝尔",
        zipCode: "021008",
        pinyin: "HULUNBER"
      },
      {
        id: 422,
        name: "巴彦淖尔",
        zipCode: "015001",
        pinyin: "BAYANNUR"
      },
      {
        id: 430,
        name: "乌兰察布",
        zipCode: "012000",
        pinyin: "ULANQAB"
      },
      {
        id: 442,
        name: "兴安盟",
        zipCode: "137401",
        pinyin: "HINGGAN"
      },
      {
        id: 449,
        name: "锡林郭勒盟",
        zipCode: "026000",
        pinyin: "XILINGOL"
      },
      {
        id: 462,
        name: "阿拉善盟",
        zipCode: "750306",
        pinyin: "ALXA"
      }
    ]
  },
  {
    id: 466,
    name: "辽宁",
    pinyin: "LIAONING",
    children: [
      {
        id: 467,
        name: "沈阳",
        zipCode: "110013",
        pinyin: "SHENYANG"
      },
      {
        id: 481,
        name: "大连",
        zipCode: "116011",
        pinyin: "DALIAN"
      },
      {
        id: 492,
        name: "鞍山",
        zipCode: "114001",
        pinyin: "ANSHAN"
      },
      {
        id: 500,
        name: "抚顺",
        zipCode: "113008",
        pinyin: "FUSHUN"
      },
      {
        id: 508,
        name: "本溪",
        zipCode: "117000",
        pinyin: "BENXI"
      },
      {
        id: 515,
        name: "丹东",
        zipCode: "118000",
        pinyin: "DANDONG"
      },
      {
        id: 522,
        name: "锦州",
        zipCode: "121000",
        pinyin: "JINZHOU"
      },
      {
        id: 530,
        name: "营口",
        zipCode: "115003",
        pinyin: "YINGKOU"
      },
      {
        id: 537,
        name: "阜新",
        zipCode: "123000",
        pinyin: "FUXIN"
      },
      {
        id: 545,
        name: "辽阳",
        zipCode: "111000",
        pinyin: "LIAOYANG"
      },
      {
        id: 553,
        name: "盘锦",
        zipCode: "124010",
        pinyin: "PANJIN"
      },
      {
        id: 558,
        name: "铁岭",
        zipCode: "112000",
        pinyin: "TIELING"
      },
      {
        id: 566,
        name: "朝阳",
        zipCode: "122000",
        pinyin: "CHAOYANG"
      },
      {
        id: 574,
        name: "葫芦岛",
        zipCode: "125000",
        pinyin: "HULUDAO"
      },
      {
        id: 581,
        name: "金普新区",
        zipCode: "116100",
        pinyin: "JINPUXINQU"
      }
    ]
  },
  {
    id: 585,
    name: "吉林",
    pinyin: "JILIN",
    children: [
      {
        id: 586,
        name: "长春",
        zipCode: "130022",
        pinyin: "CHANGCHUN"
      },
      {
        id: 597,
        name: "吉林",
        zipCode: "132011",
        pinyin: "JILIN"
      },
      {
        id: 607,
        name: "四平",
        zipCode: "136000",
        pinyin: "SIPING"
      },
      {
        id: 614,
        name: "辽源",
        zipCode: "136200",
        pinyin: "LIAOYUAN"
      },
      {
        id: 619,
        name: "通化",
        zipCode: "134001",
        pinyin: "TONGHUA"
      },
      {
        id: 627,
        name: "白山",
        zipCode: "134300",
        pinyin: "BAISHAN"
      },
      {
        id: 634,
        name: "松原",
        zipCode: "138000",
        pinyin: "SONGYUAN"
      },
      {
        id: 640,
        name: "白城",
        zipCode: "137000",
        pinyin: "BAICHENG"
      },
      {
        id: 646,
        name: "延边",
        zipCode: "133000",
        pinyin: "YANBIAN"
      }
    ]
  },
  {
    id: 655,
    name: "黑龙江",
    pinyin: "HEILONGJIANG",
    children: [
      {
        id: 656,
        name: "哈尔滨",
        zipCode: "150010",
        pinyin: "HARBIN"
      },
      {
        id: 675,
        name: "齐齐哈尔",
        zipCode: "161005",
        pinyin: "QIQIHAR"
      },
      {
        id: 692,
        name: "鸡西",
        zipCode: "158100",
        pinyin: "JIXI"
      },
      {
        id: 702,
        name: "鹤岗",
        zipCode: "154100",
        pinyin: "HEGANG"
      },
      {
        id: 711,
        name: "双鸭山",
        zipCode: "155100",
        pinyin: "SHUANGYASHAN"
      },
      {
        id: 720,
        name: "大庆",
        zipCode: "163000",
        pinyin: "DAQING"
      },
      {
        id: 730,
        name: "伊春",
        zipCode: "153000",
        pinyin: "YICHUN"
      },
      {
        id: 748,
        name: "佳木斯",
        zipCode: "154002",
        pinyin: "JIAMUSI"
      },
      {
        id: 759,
        name: "七台河",
        zipCode: "154600",
        pinyin: "QITAIHE"
      },
      {
        id: 764,
        name: "牡丹江",
        zipCode: "157000",
        pinyin: "MUDANJIANG"
      },
      {
        id: 775,
        name: "黑河",
        zipCode: "164300",
        pinyin: "HEIHE"
      },
      {
        id: 782,
        name: "绥化",
        zipCode: "152000",
        pinyin: "SUIHUA"
      },
      {
        id: 793,
        name: "大兴安岭",
        zipCode: "165000",
        pinyin: "DAXINGANLING"
      }
    ]
  },
  {
    id: 801,
    name: "上海",
    pinyin: "SHANGHAI",
    children: [
      {
        id: 802,
        name: "上海",
        zipCode: "200000",
        pinyin: "SHANGHAI"
      }
    ]
  },
  {
    id: 820,
    name: "江苏",
    pinyin: "JIANGSU",
    children: [
      {
        id: 821,
        name: "南京",
        zipCode: "210008",
        pinyin: "NANJING"
      },
      {
        id: 833,
        name: "无锡",
        zipCode: "214000",
        pinyin: "WUXI"
      },
      {
        id: 842,
        name: "徐州",
        zipCode: "221003",
        pinyin: "XUZHOU"
      },
      {
        id: 853,
        name: "常州",
        zipCode: "213000",
        pinyin: "CHANGZHOU"
      },
      {
        id: 861,
        name: "苏州",
        zipCode: "215002",
        pinyin: "SUZHOU"
      },
      {
        id: 871,
        name: "南通",
        zipCode: "226001",
        pinyin: "NANTONG"
      },
      {
        id: 880,
        name: "连云港",
        zipCode: "222002",
        pinyin: "LIANYUNGANG"
      },
      {
        id: 887,
        name: "淮安",
        zipCode: "223001",
        pinyin: "HUAI'AN"
      },
      {
        id: 896,
        name: "盐城",
        zipCode: "224005",
        pinyin: "YANCHENG"
      },
      {
        id: 906,
        name: "扬州",
        zipCode: "225002",
        pinyin: "YANGZHOU"
      },
      {
        id: 913,
        name: "镇江",
        zipCode: "212004",
        pinyin: "ZHENJIANG"
      },
      {
        id: 920,
        name: "泰州",
        zipCode: "225300",
        pinyin: "TAIZHOU"
      },
      {
        id: 927,
        name: "宿迁",
        zipCode: "223800",
        pinyin: "SUQIAN"
      }
    ]
  },
  {
    id: 933,
    name: "浙江",
    pinyin: "ZHEJIANG",
    children: [
      {
        id: 934,
        name: "杭州",
        zipCode: "310026",
        pinyin: "HANGZHOU"
      },
      {
        id: 948,
        name: "宁波",
        zipCode: "315000",
        pinyin: "NINGBO"
      },
      {
        id: 960,
        name: "温州",
        zipCode: "325000",
        pinyin: "WENZHOU"
      },
      {
        id: 972,
        name: "嘉兴",
        zipCode: "314000",
        pinyin: "JIAXING"
      },
      {
        id: 980,
        name: "湖州",
        zipCode: "313000",
        pinyin: "HUZHOU"
      },
      {
        id: 986,
        name: "绍兴",
        zipCode: "312000",
        pinyin: "SHAOXING"
      },
      {
        id: 993,
        name: "金华",
        zipCode: "321000",
        pinyin: "JINHUA"
      },
      {
        id: 1003,
        name: "衢州",
        zipCode: "324002",
        pinyin: "QUZHOU"
      },
      {
        id: 1010,
        name: "舟山",
        zipCode: "316000",
        pinyin: "ZHOUSHAN"
      },
      {
        id: 1015,
        name: "台州",
        zipCode: "318000",
        pinyin: "TAIZHOU"
      },
      {
        id: 1025,
        name: "丽水",
        zipCode: "323000",
        pinyin: "LISHUI"
      },
      {
        id: 1035,
        name: "舟山新区",
        zipCode: "316000",
        pinyin: "ZHOUSHAN"
      }
    ]
  },
  {
    id: 1046,
    name: "安徽",
    pinyin: "ANHUI",
    children: [
      {
        id: 1047,
        name: "合肥",
        zipCode: "230001",
        pinyin: "HEFEI"
      },
      {
        id: 1057,
        name: "芜湖",
        zipCode: "241000",
        pinyin: "WUHU"
      },
      {
        id: 1066,
        name: "蚌埠",
        zipCode: "233000",
        pinyin: "BENGBU"
      },
      {
        id: 1074,
        name: "淮南",
        zipCode: "232001",
        pinyin: "HUAINAN"
      },
      {
        id: 1081,
        name: "马鞍山",
        zipCode: "243001",
        pinyin: "MA'ANSHAN"
      },
      {
        id: 1088,
        name: "淮北",
        zipCode: "235000",
        pinyin: "HUAIBEI"
      },
      {
        id: 1093,
        name: "铜陵",
        zipCode: "244000",
        pinyin: "TONGLING"
      },
      {
        id: 1098,
        name: "安庆",
        zipCode: "246001",
        pinyin: "ANQING"
      },
      {
        id: 1110,
        name: "黄山",
        zipCode: "245000",
        pinyin: "HUANGSHAN"
      },
      {
        id: 1118,
        name: "滁州",
        zipCode: "239000",
        pinyin: "CHUZHOU"
      },
      {
        id: 1127,
        name: "阜阳",
        zipCode: "236033",
        pinyin: "FUYANG"
      },
      {
        id: 1136,
        name: "宿州",
        zipCode: "234000",
        pinyin: "SUZHOU"
      },
      {
        id: 1142,
        name: "六安",
        zipCode: "237000",
        pinyin: "LU'AN"
      },
      {
        id: 1150,
        name: "亳州",
        zipCode: "236802",
        pinyin: "BOZHOU"
      },
      {
        id: 1155,
        name: "池州",
        zipCode: "247100",
        pinyin: "CHIZHOU"
      },
      {
        id: 1160,
        name: "宣城",
        zipCode: "242000",
        pinyin: "XUANCHENG"
      }
    ]
  },
  {
    id: 1168,
    name: "福建",
    pinyin: "FUJIAN",
    children: [
      {
        id: 1169,
        name: "福州",
        zipCode: "350001",
        pinyin: "FUZHOU"
      },
      {
        id: 1183,
        name: "厦门",
        zipCode: "361003",
        pinyin: "XIAMEN"
      },
      {
        id: 1190,
        name: "莆田",
        zipCode: "351100",
        pinyin: "PUTIAN"
      },
      {
        id: 1196,
        name: "三明",
        zipCode: "365000",
        pinyin: "SANMING"
      },
      {
        id: 1209,
        name: "泉州",
        zipCode: "362000",
        pinyin: "QUANZHOU"
      },
      {
        id: 1222,
        name: "漳州",
        zipCode: "363005",
        pinyin: "ZHANGZHOU"
      },
      {
        id: 1234,
        name: "南平",
        zipCode: "353000",
        pinyin: "NANPING"
      },
      {
        id: 1245,
        name: "龙岩",
        zipCode: "364000",
        pinyin: "LONGYAN"
      },
      {
        id: 1253,
        name: "宁德",
        zipCode: "352100",
        pinyin: "NINGDE"
      }
    ]
  },
  {
    id: 1263,
    name: "江西",
    pinyin: "JIANGXI",
    children: [
      {
        id: 1264,
        name: "南昌",
        zipCode: "330008",
        pinyin: "NANCHANG"
      },
      {
        id: 1274,
        name: "景德镇",
        zipCode: "333000",
        pinyin: "JINGDEZHEN"
      },
      {
        id: 1279,
        name: "萍乡",
        zipCode: "337000",
        pinyin: "PINGXIANG"
      },
      {
        id: 1285,
        name: "九江",
        zipCode: "332000",
        pinyin: "JIUJIANG"
      },
      {
        id: 1299,
        name: "新余",
        zipCode: "338025",
        pinyin: "XINYU"
      },
      {
        id: 1302,
        name: "鹰潭",
        zipCode: "335000",
        pinyin: "YINGTAN"
      },
      {
        id: 1306,
        name: "赣州",
        zipCode: "341000",
        pinyin: "GANZHOU"
      },
      {
        id: 1325,
        name: "吉安",
        zipCode: "343000",
        pinyin: "JI'AN"
      },
      {
        id: 1339,
        name: "宜春",
        zipCode: "336000",
        pinyin: "YICHUN"
      },
      {
        id: 1350,
        name: "抚州",
        zipCode: "344000",
        pinyin: "FUZHOU"
      },
      {
        id: 1362,
        name: "上饶",
        zipCode: "334000",
        pinyin: "SHANGRAO"
      }
    ]
  },
  {
    id: 1375,
    name: "山东",
    pinyin: "SHANDONG",
    children: [
      {
        id: 1376,
        name: "济南",
        zipCode: "250001",
        pinyin: "JINAN"
      },
      {
        id: 1387,
        name: "青岛",
        zipCode: "266001",
        pinyin: "QINGDAO"
      },
      {
        id: 1399,
        name: "淄博",
        zipCode: "255039",
        pinyin: "ZIBO"
      },
      {
        id: 1408,
        name: "枣庄",
        zipCode: "277101",
        pinyin: "ZAOZHUANG"
      },
      {
        id: 1415,
        name: "东营",
        zipCode: "257093",
        pinyin: "DONGYING"
      },
      {
        id: 1421,
        name: "烟台",
        zipCode: "264010",
        pinyin: "YANTAI"
      },
      {
        id: 1434,
        name: "潍坊",
        zipCode: "261041",
        pinyin: "WEIFANG"
      },
      {
        id: 1447,
        name: "济宁",
        zipCode: "272119",
        pinyin: "JINING"
      },
      {
        id: 1459,
        name: "泰安",
        zipCode: "271000",
        pinyin: "TAI'AN"
      },
      {
        id: 1466,
        name: "威海",
        zipCode: "264200",
        pinyin: "WEIHAI"
      },
      {
        id: 1471,
        name: "日照",
        zipCode: "276800",
        pinyin: "RIZHAO"
      },
      {
        id: 1476,
        name: "莱芜",
        zipCode: "271100",
        pinyin: "LAIWU"
      },
      {
        id: 1479,
        name: "临沂",
        zipCode: "253000",
        pinyin: "LINYI"
      },
      {
        id: 1492,
        name: "德州",
        zipCode: "253000",
        pinyin: "DEZHOU"
      },
      {
        id: 1504,
        name: "聊城",
        zipCode: "252052",
        pinyin: "LIAOCHENG"
      },
      {
        id: 1513,
        name: "滨州",
        zipCode: "256619",
        pinyin: "BINZHOU"
      },
      {
        id: 1522,
        name: "菏泽",
        zipCode: "274020",
        pinyin: "HEZE"
      }
    ]
  },
  {
    id: 1532,
    name: "河南",
    pinyin: "HENAN",
    children: [
      {
        id: 1533,
        name: "郑州",
        zipCode: "450000",
        pinyin: "ZHENGZHOU"
      },
      {
        id: 1546,
        name: "开封",
        zipCode: "475001",
        pinyin: "KAIFENG"
      },
      {
        id: 1556,
        name: "洛阳",
        zipCode: "471000",
        pinyin: "LUOYANG"
      },
      {
        id: 1572,
        name: "平顶山",
        zipCode: "467000",
        pinyin: "PINGDINGSHAN"
      },
      {
        id: 1583,
        name: "安阳",
        zipCode: "455000",
        pinyin: "ANYANG"
      },
      {
        id: 1593,
        name: "鹤壁",
        zipCode: "458030",
        pinyin: "HEBI"
      },
      {
        id: 1599,
        name: "新乡",
        zipCode: "453000",
        pinyin: "XINXIANG"
      },
      {
        id: 1612,
        name: "焦作",
        zipCode: "454002",
        pinyin: "JIAOZUO"
      },
      {
        id: 1623,
        name: "濮阳",
        zipCode: "457000",
        pinyin: "PUYANG"
      },
      {
        id: 1630,
        name: "许昌",
        zipCode: "461000",
        pinyin: "XUCHANG"
      },
      {
        id: 1637,
        name: "漯河",
        zipCode: "462000",
        pinyin: "LUOHE"
      },
      {
        id: 1643,
        name: "三门峡",
        zipCode: "472000",
        pinyin: "SANMENXIA"
      },
      {
        id: 1650,
        name: "南阳",
        zipCode: "473002",
        pinyin: "NANYANG"
      },
      {
        id: 1664,
        name: "商丘",
        zipCode: "476000",
        pinyin: "SHANGQIU"
      },
      {
        id: 1674,
        name: "信阳",
        zipCode: "464000",
        pinyin: "XINYANG"
      },
      {
        id: 1685,
        name: "周口",
        zipCode: "466000",
        pinyin: "ZHOUKOU"
      },
      {
        id: 1696,
        name: "驻马店",
        zipCode: "463000",
        pinyin: "ZHUMADIAN"
      }
    ]
  },
  {
    id: 1709,
    name: "湖北",
    pinyin: "HUBEI",
    children: [
      {
        id: 1710,
        name: "武汉",
        zipCode: "430014",
        pinyin: "WUHAN"
      },
      {
        id: 1724,
        name: "黄石",
        zipCode: "435003",
        pinyin: "HUANGSHI"
      },
      {
        id: 1731,
        name: "十堰",
        zipCode: "442000",
        pinyin: "SHIYAN"
      },
      {
        id: 1740,
        name: "宜昌",
        zipCode: "443000",
        pinyin: "YICHANG"
      },
      {
        id: 1754,
        name: "襄阳",
        zipCode: "441021",
        pinyin: "XIANGYANG"
      },
      {
        id: 1764,
        name: "鄂州",
        zipCode: "436000",
        pinyin: "EZHOU"
      },
      {
        id: 1768,
        name: "荆门",
        zipCode: "448000",
        pinyin: "JINGMEN"
      },
      {
        id: 1774,
        name: "孝感",
        zipCode: "432100",
        pinyin: "XIAOGAN"
      },
      {
        id: 1782,
        name: "荆州",
        zipCode: "434000",
        pinyin: "JINGZHOU"
      },
      {
        id: 1791,
        name: "黄冈",
        zipCode: "438000",
        pinyin: "HUANGGANG"
      },
      {
        id: 1802,
        name: "咸宁",
        zipCode: "437000",
        pinyin: "XIANNING"
      },
      {
        id: 1809,
        name: "随州",
        zipCode: "441300",
        pinyin: "SUIZHOU"
      },
      {
        id: 1813,
        name: "恩施",
        zipCode: "445000",
        pinyin: "ENSHI"
      },
    ]
  },
  {
    id: 1827,
    name: "湖南",
    pinyin: "HUNAN",
    children: [
      {
        id: 1828,
        name: "长沙",
        zipCode: "410005",
        pinyin: "CHANGSHA"
      },
      {
        id: 1838,
        name: "株洲",
        zipCode: "412000",
        pinyin: "ZHUZHOU"
      },
      {
        id: 1848,
        name: "湘潭",
        zipCode: "411100",
        pinyin: "XIANGTAN"
      },
      {
        id: 1854,
        name: "衡阳",
        zipCode: "421001",
        pinyin: "HENGYANG"
      },
      {
        id: 1867,
        name: "邵阳",
        zipCode: "422000",
        pinyin: "SHAOYANG"
      },
      {
        id: 1880,
        name: "岳阳",
        zipCode: "414000",
        pinyin: "YUEYANG"
      },
      {
        id: 1890,
        name: "常德",
        zipCode: "415000",
        pinyin: "CHANGDE"
      },
      {
        id: 1900,
        name: "张家界",
        zipCode: "427000",
        pinyin: "ZHANGJIAJIE"
      },
      {
        id: 1905,
        name: "益阳",
        zipCode: "413000",
        pinyin: "YIYANG"
      },
      {
        id: 1912,
        name: "郴州",
        zipCode: "423000",
        pinyin: "CHENZHOU"
      },
      {
        id: 1924,
        name: "永州",
        zipCode: "425000",
        pinyin: "YONGZHOU"
      },
      {
        id: 1936,
        name: "怀化",
        zipCode: "418000",
        pinyin: "HUAIHUA"
      },
      {
        id: 1949,
        name: "娄底",
        zipCode: "417000",
        pinyin: "LOUDI"
      },
      {
        id: 1955,
        name: "湘西",
        zipCode: "416000",
        pinyin: "XIANGXI"
      }
    ]
  },
  {
    id: 1964,
    name: "广东",
    pinyin: "GUANGDONG",
    children: [
      {
        id: 1965,
        name: "广州",
        zipCode: "510032",
        pinyin: "GUANGZHOU"
      },
      {
        id: 1977,
        name: "韶关",
        zipCode: "512002",
        pinyin: "SHAOGUAN"
      },
      {
        id: 1988,
        name: "深圳",
        zipCode: "518035",
        pinyin: "SHENZHEN"
      },
      {
        id: 1999,
        name: "珠海",
        zipCode: "519000",
        pinyin: "ZHUHAI"
      },
      {
        id: 2003,
        name: "汕头",
        zipCode: "515041",
        pinyin: "SHANTOU"
      },
      {
        id: 2011,
        name: "佛山",
        zipCode: "528000",
        pinyin: "FOSHAN"
      },
      {
        id: 2017,
        name: "江门",
        zipCode: "529000",
        pinyin: "JIANGMEN"
      },
      {
        id: 2025,
        name: "湛江",
        zipCode: "524047",
        pinyin: "ZHANJIANG"
      },
      {
        id: 2035,
        name: "茂名",
        zipCode: "525000",
        pinyin: "MAOMING"
      },
      {
        id: 2041,
        name: "肇庆",
        zipCode: "526040",
        pinyin: "ZHAOQING"
      },
      {
        id: 2050,
        name: "惠州",
        zipCode: "516000",
        pinyin: "HUIZHOU"
      },
      {
        id: 2056,
        name: "梅州",
        zipCode: "514021",
        pinyin: "MEIZHOU"
      },
      {
        id: 2065,
        name: "汕尾",
        zipCode: "516600",
        pinyin: "SHANWEI"
      },
      {
        id: 2070,
        name: "河源",
        zipCode: "517000",
        pinyin: "HEYUAN"
      },
      {
        id: 2077,
        name: "阳江",
        zipCode: "529500",
        pinyin: "YANGJIANG"
      },
      {
        id: 2082,
        name: "清远",
        zipCode: "511500",
        pinyin: "QINGYUAN"
      },
      {
        id: 2091,
        name: "东莞",
        zipCode: "523888",
        pinyin: "DONGGUAN"
      },
      {
        id: 2123,
        name: "中山",
        zipCode: "528403",
        pinyin: "ZHONGSHAN"
      },
      {
        id: 2146,
        name: "潮州",
        zipCode: "521000",
        pinyin: "CHAOZHOU"
      },
      {
        id: 2150,
        name: "揭阳",
        zipCode: "522000",
        pinyin: "JIEYANG"
      },
      {
        id: 2156,
        name: "云浮",
        zipCode: "527300",
        pinyin: "YUNFU"
      }
    ]
  },
  {
    id: 2162,
    name: "广西",
    pinyin: "GUANGXI",
    children: [
      {
        id: 2163,
        name: "南宁",
        zipCode: "530028",
        pinyin: "NANNING"
      },
      {
        id: 2177,
        name: "柳州",
        zipCode: "545001",
        pinyin: "LIUZHOU"
      },
      {
        id: 2189,
        name: "桂林",
        zipCode: "541100",
        pinyin: "GUILIN"
      },
      {
        id: 2207,
        name: "梧州",
        zipCode: "543002",
        pinyin: "WUZHOU"
      },
      {
        id: 2215,
        name: "北海",
        zipCode: "536000",
        pinyin: "BEIHAI"
      },
      {
        id: 2220,
        name: "防城港",
        zipCode: "538001",
        pinyin: "FANGCHENGGANG"
      },
      {
        id: 2225,
        name: "钦州",
        zipCode: "535099",
        pinyin: "QINZHOU"
      },
      {
        id: 2230,
        name: "贵港",
        zipCode: "537100",
        pinyin: "GUIGANG"
      },
      {
        id: 2236,
        name: "玉林",
        zipCode: "537000",
        pinyin: "YULIN"
      },
      {
        id: 2245,
        name: "百色",
        zipCode: "533000",
        pinyin: "BAISE"
      },
      {
        id: 2258,
        name: "贺州",
        zipCode: "542800",
        pinyin: "HEZHOU"
      },
      {
        id: 2264,
        name: "河池",
        zipCode: "547000",
        pinyin: "HECHI"
      },
      {
        id: 2276,
        name: "来宾",
        zipCode: "546100",
        pinyin: "LAIBIN"
      },
      {
        id: 2283,
        name: "崇左",
        zipCode: "532299",
        pinyin: "CHONGZUO"
      }
    ]
  },
  {
    id: 2291,
    name: "海南",
    pinyin: "HAINAN",
    children: [
      {
        id: 2292,
        name: "海口",
        zipCode: "570000",
        pinyin: "HAIKOU"
      },
      {
        id: 2297,
        name: "三亚",
        zipCode: "572000",
        pinyin: "SANYA"
      },
      {
        id: 2302,
        name: "三沙",
        zipCode: "573199",
        pinyin: "SANSHA"
      },
    ]
  },
  {
    id: 2323,
    name: "重庆",
    pinyin: "CHONGQING",
    children: [
      {
        id: 2324,
        name: "重庆",
        zipCode: "400000",
        pinyin: "CHONGQING"
      },
      {
        id: 2363,
        name: "两江新区",
        zipCode: "400000",
        pinyin: "LIANGJIANGXINQU"
      }
    ]
  },
  {
    id: 2367,
    name: "四川",
    pinyin: "SICHUAN",
    children: [
      {
        id: 2368,
        name: "成都",
        zipCode: "610015",
        pinyin: "CHENGDU"
      },
      {
        id: 2388,
        name: "自贡",
        zipCode: "643000",
        pinyin: "ZIGONG"
      },
      {
        id: 2395,
        name: "攀枝花",
        zipCode: "617000",
        pinyin: "PANZHIHUA"
      },
      {
        id: 2401,
        name: "泸州",
        zipCode: "646000",
        pinyin: "LUZHOU"
      },
      {
        id: 2409,
        name: "德阳",
        zipCode: "618000",
        pinyin: "DEYANG"
      },
      {
        id: 2416,
        name: "绵阳",
        zipCode: "621000",
        pinyin: "MIANYANG"
      },
      {
        id: 2426,
        name: "广元",
        zipCode: "628000",
        pinyin: "GUANGYUAN"
      },
      {
        id: 2434,
        name: "遂宁",
        zipCode: "629000",
        pinyin: "SUINING"
      },
      {
        id: 2440,
        name: "内江",
        zipCode: "641000",
        pinyin: "NEIJIANG"
      },
      {
        id: 2446,
        name: "乐山",
        zipCode: "614000",
        pinyin: "LESHAN"
      },
      {
        id: 2458,
        name: "南充",
        zipCode: "637000",
        pinyin: "NANCHONG"
      },
      {
        id: 2468,
        name: "眉山",
        zipCode: "620020",
        pinyin: "MEISHAN"
      },
      {
        id: 2475,
        name: "宜宾",
        zipCode: "644000",
        pinyin: "YIBIN"
      },
      {
        id: 2486,
        name: "广安",
        zipCode: "638000",
        pinyin: "GUANG'AN"
      },
      {
        id: 2493,
        name: "达州",
        zipCode: "635000",
        pinyin: "DAZHOU"
      },
      {
        id: 2501,
        name: "雅安",
        zipCode: "625000",
        pinyin: "YA'AN"
      },
      {
        id: 2510,
        name: "巴中",
        zipCode: "636000",
        pinyin: "BAZHONG"
      },
      {
        id: 2516,
        name: "资阳",
        zipCode: "641300",
        pinyin: "ZIYANG"
      },
      {
        id: 2521,
        name: "阿坝",
        zipCode: "624000",
        pinyin: "ABA"
      },
      {
        id: 2535,
        name: "甘孜",
        zipCode: "626000",
        pinyin: "GARZE"
      },
      {
        id: 2554,
        name: "凉山",
        zipCode: "615000",
        pinyin: "LIANGSHAN"
      }
    ]
  },
  {
    id: 2572,
    name: "贵州",
    pinyin: "GUIZHOU",
    children: [
      {
        id: 2573,
        name: "贵阳",
        zipCode: "550001",
        pinyin: "GUIYANG"
      },
      {
        id: 2584,
        name: "六盘水",
        zipCode: "553400",
        pinyin: "LIUPANSHUI"
      },
      {
        id: 2589,
        name: "遵义",
        zipCode: "563000",
        pinyin: "ZUNYI"
      },
      {
        id: 2604,
        name: "安顺",
        zipCode: "561000",
        pinyin: "ANSHUN"
      },
      {
        id: 2611,
        name: "毕节",
        zipCode: "551700",
        pinyin: "BIJIE"
      },
      {
        id: 2620,
        name: "铜仁",
        zipCode: "554300",
        pinyin: "TONGREN"
      },
      {
        id: 2631,
        name: "黔西南",
        zipCode: "562400",
        pinyin: "QIANXINAN"
      },
      {
        id: 2640,
        name: "黔东南",
        zipCode: "556000",
        pinyin: "QIANDONGNAN"
      },
      {
        id: 2657,
        name: "黔南",
        zipCode: "558000",
        pinyin: "QIANNAN"
      }
    ]
  },
  {
    id: 2670,
    name: "云南",
    pinyin: "YUNNAN",
    children: [
      {
        id: 2671,
        name: "昆明",
        zipCode: "650500",
        pinyin: "KUNMING"
      },
      {
        id: 2686,
        name: "曲靖",
        zipCode: "655000",
        pinyin: "QUJING"
      },
      {
        id: 2696,
        name: "玉溪",
        zipCode: "653100",
        pinyin: "YUXI"
      },
      {
        id: 2706,
        name: "保山",
        zipCode: "678000",
        pinyin: "BAOSHAN"
      },
      {
        id: 2712,
        name: "昭通",
        zipCode: "657000",
        pinyin: "ZHAOTONG"
      },
      {
        id: 2724,
        name: "丽江",
        zipCode: "674100",
        pinyin: "LIJIANG"
      },
      {
        id: 2730,
        name: "普洱",
        zipCode: "665000",
        pinyin: "PU'ER"
      },
      {
        id: 2741,
        name: "临沧",
        zipCode: "677000",
        pinyin: "LINCANG"
      },
      {
        id: 2750,
        name: "楚雄",
        zipCode: "675000",
        pinyin: "CHUXIONG"
      },
      {
        id: 2761,
        name: "红河",
        zipCode: "661400",
        pinyin: "HONGHE"
      },
      {
        id: 2775,
        name: "文山",
        zipCode: "663000",
        pinyin: "WENSHAN"
      },
      {
        id: 2784,
        name: "西双版纳",
        zipCode: "666100",
        pinyin: "XISHUANGBANNA"
      },
      {
        id: 2788,
        name: "大理",
        zipCode: "671000",
        pinyin: "DALI"
      },
      {
        id: 2801,
        name: "德宏",
        zipCode: "678400",
        pinyin: "DEHONG"
      },
      {
        id: 2807,
        name: "怒江",
        zipCode: "673100",
        pinyin: "NUJIANG"
      },
      {
        id: 2812,
        name: "迪庆",
        zipCode: "674400",
        pinyin: "DEQEN"
      }
    ]
  },
  {
    id: 2816,
    name: "西藏",
    pinyin: "TIBET",
    children: [
      {
        id: 2817,
        name: "拉萨",
        zipCode: "850000",
        pinyin: "LHASA"
      },
      {
        id: 2826,
        name: "日喀则",
        zipCode: "857000",
        pinyin: "RIKAZE"
      },
      {
        id: 2845,
        name: "昌都",
        zipCode: "854000",
        pinyin: "QAMDO"
      },
      {
        id: 2857,
        name: "山南",
        zipCode: "856000",
        pinyin: "SHANNAN"
      },
      {
        id: 2870,
        name: "那曲",
        zipCode: "852000",
        pinyin: "NAGQU"
      },
      {
        id: 2882,
        name: "阿里",
        zipCode: "859000",
        pinyin: "NGARI"
      },
      {
        id: 2890,
        name: "林芝",
        zipCode: "850400",
        pinyin: "NYINGCHI"
      }
    ]
  },
  {
    id: 2898,
    name: "陕西",
    pinyin: "SHAANXI",
    children: [
      {
        id: 2899,
        name: "西安",
        zipCode: "710003",
        pinyin: "XI'AN"
      },
      {
        id: 2913,
        name: "铜川",
        zipCode: "727100",
        pinyin: "TONGCHUAN"
      },
      {
        id: 2918,
        name: "宝鸡",
        zipCode: "721000",
        pinyin: "BAOJI"
      },
      {
        id: 2931,
        name: "咸阳",
        zipCode: "712000",
        pinyin: "XIANYANG"
      },
      {
        id: 2946,
        name: "渭南",
        zipCode: "714000",
        pinyin: "WEINAN"
      },
      {
        id: 2958,
        name: "延安",
        zipCode: "716000",
        pinyin: "YAN'AN"
      },
      {
        id: 2972,
        name: "汉中",
        zipCode: "723000",
        pinyin: "HANZHONG"
      },
      {
        id: 2984,
        name: "榆林",
        zipCode: "719000",
        pinyin: "YULIN"
      },
      {
        id: 2997,
        name: "安康",
        zipCode: "725000",
        pinyin: "ANKANG"
      },
      {
        id: 3008,
        name: "商洛",
        zipCode: "726000",
        pinyin: "SHANGLUO"
      },
      {
        id: 3016,
        name: "西咸",
        zipCode: "712000",
        pinyin: "XIXIAN"
      }
    ]
  },
  {
    id: 3022,
    name: "甘肃",
    pinyin: "GANSU",
    children: [
      {
        id: 3023,
        name: "兰州",
        zipCode: "730030",
        pinyin: "LANZHOU"
      },
      {
        id: 3032,
        name: "嘉峪关",
        zipCode: "735100",
        pinyin: "JIAYUGUAN"
      },
      {
        id: 3036,
        name: "金昌",
        zipCode: "737100",
        pinyin: "JINCHANG"
      },
      {
        id: 3039,
        name: "白银",
        zipCode: "730900",
        pinyin: "BAIYIN"
      },
      {
        id: 3045,
        name: "天水",
        zipCode: "741000",
        pinyin: "TIANSHUI"
      },
      {
        id: 3053,
        name: "武威",
        zipCode: "733000",
        pinyin: "WUWEI"
      },
      {
        id: 3058,
        name: "张掖",
        zipCode: "734000",
        pinyin: "ZHANGYE"
      },
      {
        id: 3065,
        name: "平凉",
        zipCode: "744000",
        pinyin: "PINGLIANG"
      },
      {
        id: 3073,
        name: "酒泉",
        zipCode: "735000",
        pinyin: "JIUQUAN"
      },
      {
        id: 3081,
        name: "庆阳",
        zipCode: "745000",
        pinyin: "QINGYANG"
      },
      {
        id: 3090,
        name: "定西",
        zipCode: "743000",
        pinyin: "DINGXI"
      },
      {
        id: 3098,
        name: "陇南",
        zipCode: "746000",
        pinyin: "LONGNAN"
      },
      {
        id: 3108,
        name: "临夏",
        zipCode: "731100",
        pinyin: "LINXIA"
      },
      {
        id: 3117,
        name: "甘南",
        zipCode: "747000",
        pinyin: "GANNAN"
      }
    ]
  },
  {
    id: 3126,
    name: "青海",
    pinyin: "QINGHAI",
    children: [
      {
        id: 3127,
        name: "西宁",
        zipCode: "810000",
        pinyin: "XINING"
      },
      {
        id: 3135,
        name: "海东",
        zipCode: "810700",
        pinyin: "HAIDONG"
      },
      {
        id: 3142,
        name: "海北",
        zipCode: "812200",
        pinyin: "HAIBEI"
      },
      {
        id: 3147,
        name: "黄南",
        zipCode: "811300",
        pinyin: "HUANGNAN"
      },
      {
        id: 3152,
        name: "海南",
        zipCode: "813000",
        pinyin: "HAINAN"
      },
      {
        id: 3158,
        name: "果洛",
        zipCode: "814000",
        pinyin: "GOLOG"
      },
      {
        id: 3165,
        name: "玉树",
        zipCode: "815000",
        pinyin: "YUSHU"
      },
      {
        id: 3172,
        name: "海西",
        zipCode: "817000",
        pinyin: "HAIXI"
      }
    ]
  },
  {
    id: 3178,
    name: "宁夏",
    pinyin: "NINGXIA",
    children: [
      {
        id: 3179,
        name: "银川",
        zipCode: "750004",
        pinyin: "YINCHUAN"
      },
      {
        id: 3186,
        name: "石嘴山",
        zipCode: "753000",
        pinyin: "SHIZUISHAN"
      },
      {
        id: 3190,
        name: "吴忠",
        zipCode: "751100",
        pinyin: "WUZHONG"
      },
      {
        id: 3196,
        name: "固原",
        zipCode: "756000",
        pinyin: "GUYUAN"
      },
      {
        id: 3202,
        name: "中卫",
        zipCode: "751700",
        pinyin: "ZHONGWEI"
      }
    ]
  },
  {
    id: 3206,
    name: "新疆",
    pinyin: "XINJIANG",
    children: [
      {
        id: 3207,
        name: "乌鲁木齐",
        zipCode: "830002",
        pinyin: "URUMQI"
      },
      {
        id: 3216,
        name: "克拉玛依",
        zipCode: "834000",
        pinyin: "KARAMAY"
      },
      {
        id: 3221,
        name: "吐鲁番",
        zipCode: "838000",
        pinyin: "TURPAN"
      },
      {
        id: 3225,
        name: "哈密",
        zipCode: "839000",
        pinyin: "HAMI"
      },
      {
        id: 3229,
        name: "昌吉",
        zipCode: "831100",
        pinyin: "CHANGJI"
      },
      {
        id: 3237,
        name: "博尔塔拉",
        zipCode: "833400",
        pinyin: "BORTALA"
      },
      {
        id: 3242,
        name: "巴音郭楞",
        zipCode: "841000",
        pinyin: "BAYINGOL"
      },
      {
        id: 3252,
        name: "阿克苏",
        zipCode: "843000",
        pinyin: "AKSU"
      },
      {
        id: 3262,
        name: "克孜勒苏",
        zipCode: "845350",
        pinyin: "KIZILSU"
      },
      {
        id: 3267,
        name: "喀什",
        zipCode: "844000",
        pinyin: "KASHGAR"
      },
      {
        id: 3280,
        name: "和田",
        zipCode: "848000",
        pinyin: "HOTAN"
      },
      {
        id: 3289,
        name: "伊犁",
        zipCode: "835100",
        pinyin: "ILI"
      },
      {
        id: 3301,
        name: "塔城",
        zipCode: "834700",
        pinyin: "QOQEK"
      },
      {
        id: 3309,
        name: "阿勒泰",
        zipCode: "836500",
        pinyin: "ALTAY"
      },
    ]
  },
  {
    id: 3325,
    name: "台湾",
    pinyin: "TAIWAN",
    children: [
      {
        id: 3326,
        name: "台北",
        zipCode: "1",
        pinyin: "TAIPEI"
      },
      {
        id: 3339,
        name: "高雄",
        zipCode: "8",
        pinyin: "KAOHSIUNG"
      },
      {
        id: 3378,
        name: "基隆",
        zipCode: "2",
        pinyin: "KEELUNG"
      },
      {
        id: 3386,
        name: "台中",
        zipCode: "4",
        pinyin: "TAICHUNG"
      },
      {
        id: 3416,
        name: "台南",
        zipCode: "7",
        pinyin: "TAINAN"
      },
      {
        id: 3454,
        name: "新竹",
        zipCode: "3",
        pinyin: "HSINCHU"
      },
      {
        id: 3458,
        name: "嘉义",
        zipCode: "6",
        pinyin: "CHIAYI"
      },
      {
        id: 3461,
        name: "新北",
        zipCode: "2",
        pinyin: "NEWTAIPEI"
      },
      {
        id: 3491,
        name: "宜兰",
        zipCode: "2",
        pinyin: "YILAN"
      },
      {
        id: 3504,
        name: "桃园",
        zipCode: "3",
        pinyin: "TAOYUAN"
      },
      {
        id: 3518,
        name: "新竹",
        zipCode: "3",
        pinyin: "HSINCHU"
      },
      {
        id: 3532,
        name: "苗栗",
        zipCode: "3",
        pinyin: "MIAOLI"
      },
      {
        id: 3551,
        name: "彰化",
        zipCode: "5",
        pinyin: "CHANGHUA"
      },
      {
        id: 3578,
        name: "南投",
        zipCode: "5",
        pinyin: "NANTOU"
      },
      {
        id: 3592,
        name: "云林",
        zipCode: "6",
        pinyin: "YUNLIN"
      },
      {
        id: 3613,
        name: "嘉义",
        zipCode: "6",
        pinyin: "CHIAYI"
      },
      {
        id: 3632,
        name: "屏东",
        zipCode: "9",
        pinyin: "PINGTUNG"
      },
      {
        id: 3666,
        name: "台东",
        zipCode: "9",
        pinyin: "TAITUNG"
      },
      {
        id: 3683,
        name: "花莲",
        zipCode: "9",
        pinyin: "HUALIEN"
      },
      {
        id: 3697,
        name: "澎湖",
        zipCode: "8",
        pinyin: "PENGHU"
      },
      {
        id: 3704,
        name: "金门",
        zipCode: "8",
        pinyin: "JINMEN"
      },
      {
        id: 3711,
        name: "连江",
        zipCode: "2",
        pinyin: "LIENCHIANG"
      }
    ]
  },
  {
    id: 3716,
    name: "香港",
    pinyin: "HONGKONG",
    children: [
      {
        id: 3717,
        name: "香港岛",
        zipCode: "999077",
        pinyin: "HONGKONGISLAND"
      },
      {
        id: 3722,
        name: "九龙",
        zipCode: "999077",
        pinyin: "KOWLOON"
      },
      {
        id: 3728,
        name: "新界",
        zipCode: "999077",
        pinyin: "NEWTERRITORIES"
      }
    ]
  },
  {
    id: 3738,
    name: "澳门",
    pinyin: "MACAU",
    children: [
      {
        id: 3739,
        name: "澳门半岛",
        zipCode: "999078",
        pinyin: "MACAUPENINSULA"
      },
      {
        id: 3745,
        name: "氹仔岛",
        zipCode: "999078",
        pinyin: "TAIPA"
      },
      {
        id: 3747,
        name: "路环岛",
        zipCode: "999078",
        pinyin: "COLOANE"
      }
    ]
  }
];

export default arr;
